import { Route, Routes,BrowserRouter } from "react-router-dom";
import "./App.scss";
import Guest from "./components/Guest";
import Layout from "./layout/layout";

function App() {


  return (
    <BrowserRouter>
     <Routes>
      <Route path="/" element={<Layout/>}/>
      <Route path="/faculty" element={<Guest/>}/>
    </Routes>
    </BrowserRouter>
  );
}

export default App;
